import { Component, Input, OnInit } from '@angular/core';
import { Models } from '@ibexfusion/models';

@Component({
    selector: 'app-composition-wizard-meta',
    templateUrl: './composition-wizard-meta.component.html',
    styleUrls: ['./composition-wizard-meta.component.scss'],
    standalone: false
})
export class CompositionWizardMetaComponent implements OnInit {

  @Input() composition: Models.Composition;

  constructor() {
  }

  ngOnInit() {
    if (!this.composition.address) {
      this.composition.address = new Models.CompositionAddress();
      this.composition.address.populateFromJSON({
        title: null,
        street: null,
        zip: null,
        city: null,
        phoneLabel: null,
        phone: null,
        fax: null,
        email: null,
        website: null,
        logo: null,
        background: null,
        favIcon: null,
        appTitle: null
      });
    }

    if (!this.composition.location) {
      this.composition.location = new Models.CompositionLocation();
      this.composition.location.populateFromJSON({
        type: 'Point',
        coordinates: []
      });
    }
  }

}
